const doesElementHaveDefaultSrc = (element, src) =>
  element.hasAttribute('content-untouched') && element.getAttribute('src') === src;

export default doesElementHaveDefaultSrc;
